import { render, staticRenderFns } from "./16StackTest.vue?vue&type=template&id=76bbd831&"
import script from "./16StackTest.vue?vue&type=script&lang=js&"
export * from "./16StackTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports